import { useEffect, useState } from 'react';
import { StatusPill } from '@/components/primitives/status-pill';
import { ageState, dueState, MINUTE } from '@/lib/sla';

/** The clock, ticking each minute, so a chip stays true without a refetch. */
export function useNow(ms: number = MINUTE): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(timer);
  }, [ms]);
  return now;
}

export interface SlaChipProps {
  /** When it is due (`due`), or when it started waiting (`age`). */
  at: string;
  kind?: 'due' | 'age';
  resolvedAt?: string | null;
  startedAt?: string | null;
  size?: 'sm' | 'md';
}

/** "Overdue 2 d 6 h", "Due in 40 min", "Waiting 6 d 0 h". The word is always in the chip. */
export function SlaChip({
  at,
  kind = 'due',
  resolvedAt,
  startedAt,
  size,
}: Readonly<SlaChipProps>) {
  const now = useNow();
  const state =
    kind === 'age'
      ? ageState(at, now)
      : dueState(at, now, { resolvedAt, startedAt });
  if (!state) return null;
  return <StatusPill tone={state.tone} label={state.label} size={size} />;
}
